// hooks/useSettings.js
import { useEffect, useState } from "react";
import { GET_SETTINGS } from "@constants";
import APICaller from "@services/ApiRequest";
import { useAuthState } from "@store/hooks";

export function useSettings(keys = []) {
  const { isLoggedIn } = useAuthState((state) => state);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (!isLoggedIn) return;
    APICaller(GET_SETTINGS, { settings: { keys } }).then((res) => setSettings(res));
  }, [isLoggedIn]);

  return { settings };
}
